import { render, staticRenderFns } from "./SplitDocumentComplianceLayout.vue?vue&type=template&id=12f52e8d&scoped=true&"
import script from "./SplitDocumentComplianceLayout.vue?vue&type=script&lang=js&"
export * from "./SplitDocumentComplianceLayout.vue?vue&type=script&lang=js&"
import style0 from "./SplitDocumentComplianceLayout.vue?vue&type=style&index=0&id=12f52e8d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f52e8d",
  null
  
)

export default component.exports